import * as Yup from 'yup'

import {
  campaignValidation,
  getCampaignInitialValues
} from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeCampaignForm/fields'
import { formatCampaignName } from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeCampaignForm/Steps/CampaignNameStep/CampaignNameFields/helpers'
import { AD_PLACEMENTS } from '../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'
import { LABELS } from '../reusableFields/fields'

export const CUSTOM_FIELD_VALUES = 'custom_field_values'

export const getInitialValues = ({ isCampaignsExist }) => {
  const campaignsInitialValues = getCampaignInitialValues(isCampaignsExist)

  return {
    ...campaignsInitialValues,
    [AD_PLACEMENTS]: [],
    [LABELS]: [],
    [CUSTOM_FIELD_VALUES]: []
  }
}

export const validationSchema = Yup.object({
  ...campaignValidation
})

export const createCampaignPayload = ({ values, gamNetworkCode, selectedPartnership }) => {
  const campaignName = formatCampaignName(values, selectedPartnership)

  return {
    network_code: gamNetworkCode,
    name: campaignName,
    ...(values[LABELS].length && {
      [LABELS]: values[LABELS].map(label => ({
        labelId: label.id
      }))
    }),
    ...(values[CUSTOM_FIELD_VALUES].length && {
      [CUSTOM_FIELD_VALUES]: values[CUSTOM_FIELD_VALUES].map(field => ({
        custom_field_id: field.id
      }))
    })
  }
}
